import React from 'react';
export const CFIconCrop = {
    alias: 'crop',
    defaultTitle: 'Crop',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M6.556 14A.557.557 0 0 1 6 13.444V6h7.445c.306 0 .555.249.555.556V14H6.556ZM19 14h-3V6.556A2.558 2.558 0 0 0 13.445 4H6V1a1 1 0 1 0-2 0v3H1a1 1 0 1 0 0 2h3v7.444A2.559 2.559 0 0 0 6.556 16H14v3a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2Z' }))),
};
